import {Dropdown, DropdownItem, IconButton} from 'platform/components';
import styled from 'styled-components';

import i18n from '@dms/i18n';

import type {ChartCardWidth} from '../../types/ChartCardWidth';
import {ChartWidthShape} from '../ChartWidthShape/ChartWidthShape';

const CHART_CARD_WIDTHS: ChartCardWidth[] = ['full', 'half'];

// The look of the tile toolbar on the DMS home page in edit mode.
const StyledToolbar = styled.div`
  display: flex;
  align-items: center;
  height: ${({theme}) => theme.getSize(12)};
  padding: 0 ${({theme}) => theme.getSize(2)};
  background: ${({theme}) => theme.colors.general.white};
  border-radius: ${({theme}) => theme.radii.medium};
  box-shadow: ${({theme}) => theme.shadows.elevation_2};
`;

interface ChartCardToolbarProps {
  width: ChartCardWidth;
  onWidthChange: (width: ChartCardWidth) => void;
}

/** Toolbar of a chart card in edit mode: a menu that sets the card to full or half width. */
export function ChartCardToolbar(props: ChartCardToolbarProps) {
  const labels: Record<ChartCardWidth, string> = {
    full: i18n.t('general.labels.fullWidth'),
    half: i18n.t('general.labels.halfWidth'),
  };

  return (
    <StyledToolbar>
      <Dropdown
        placement="bottom-end"
        dropdownControl={
          <IconButton
            icon="action/aspect_ratio"
            size="default"
            iconSize="large"
            aria-label={i18n.t('general.actions.changeWidth')}
          />
        }
      >
        {CHART_CARD_WIDTHS.map((width) => (
          <DropdownItem
            key={width}
            label={labels[width]}
            prefix={<ChartWidthShape width={width} />}
            isActive={width === props.width}
            onClick={() => props.onWidthChange(width)}
          />
        ))}
      </Dropdown>
    </StyledToolbar>
  );
}
